var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 11,
    height: 18,
    rx: 2,
    fill: "#B4B8BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H15V5Z",
    fill: "#B4B8BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/Story.cc49ac9530ee5994ce48fbc98caf3ddd.svg";
export { ForwardRef as ReactComponent };